import { FunctionComponent } from "react";
import ProtocolLayout from "../components/ProtocolLayout";

interface EmailNDeckProps {}

const EmailNDeck: FunctionComponent<EmailNDeckProps> = () => {
  return (
    <ProtocolLayout>
      <div className="flex flex-col items-center py-12">
        <div className="mb-12 text-3xl font-bold underline">
          Emailer and Deck
        </div>
        <div className="grid lg:grid-cols-3 justify-items-center gap-y-5 lg:gap-y-0 w-4/5 mt-6 lg:mt-20">
          <a
            href="https://docs.google.com/presentation/d/1fC1CGQ3_N5U-8ercVNkhGLCVh-pwrpsg/edit?usp=sharing&ouid=108288996233220836827&rtpof=true&sd=true"
            target="_blank"
            rel="noreferrer"
          >
            <div className="relative bg-gray-100 hover:bg-gray-200 duration-300 w-72 h-64 flex flex-col items-center justify-center rounded-xl shadow-lg py-12 px-4 ">
              <div className="">
                {/* <img src="/docs/gmc1.png" alt="" className="w-32" /> */}
              </div>
              <div className="mt-12 text-black text-opacity-40 font-bold text-xl text-center">
                Create Your Own Kazam Email Signature
              </div>
            </div>
          </a>
          <a
            href="https://docs.google.com/presentation/d/1q9TNHZCaC0cK92-sJbDiKTTtXBhZfHem/edit?usp=sharing&ouid=108288996233220836827&rtpof=true&sd=true"
            target="_blank"
            rel="noreferrer"
          >
            <div className="relative bg-gray-100 hover:bg-gray-200 duration-300 w-72 h-64 flex flex-col items-center justify-center rounded-xl shadow-lg py-12 px-4 ">
              <div className="">
                {/* <img src="/docs/gmc1.png" alt="" className="w-32" /> */}
              </div>
              <div className="mt-12 text-black text-opacity-40 font-bold text-xl text-center">
                How to Add Email Signature In Gmail
              </div>
            </div>
          </a>
          <a
            href="https://drive.google.com/file/d/1rPIie5Pc78sCzqQ7X-GjBrEVmRgvGiEr/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            <div className="relative bg-gray-100 hover:bg-gray-200 duration-300 w-72 h-64 flex flex-col items-center justify-center rounded-xl shadow-lg py-12 px-4 ">
              <div className="">
                {/* <img src="/docs/gmc1.png" alt="" className="w-32" /> */}
              </div>
              <div className="mt-12 text-black text-opacity-40 font-bold text-xl">
                Our Journey
              </div>
            </div>
          </a>
        </div>
      </div>
    </ProtocolLayout>
  );
};

export default EmailNDeck;
